<dx-popup
  #propertyPopup
  [width]="popupWidth"
  [height]="'auto'"
  [showTitle]="false"
  [dragEnabled]="false"
  [deferRendering]="true"
  [showCloseButton]="false"
  [shading]="true"
  [container]="'body'"
  [(visible)]="popupVisible"
  (onHiding)="checkSelection($event)"
  (onHidden)="hide()"
  (onShown)="onPopupShown()"
  [wrapperAttr]="{ class: 'default-property-popup' }"
  [position]="popupPosition"
>
  <div class="default-property-panel">
    <div class="default-property-header">
      <div class="default-property-title">
        <h2>Select Property</h2>
        <p>
          Please select one property to setup your resident portal. You can
          easily switch between multiple properties within the portal at
          anytime.
        </p>
      </div>
    </div>

    <div class="default-property-search">
      <dx-text-box
        [(value)]="searchText"
        placeholder="Search property by name or address"
        [showClearButton]="true"
        valueChangeEvent="input"
        (onValueChanged)="onSearchChanged($event)"
      >
        <dxi-button
          name="search"
          location="before"
          [options]="{ icon: 'search', stylingMode: 'text' }"
        ></dxi-button>
      </dx-text-box>
    </div>

    <div class="default-property-list">
      <div
        *ngFor="let property of filteredProperties"
        class="default-property-item"
        [ngClass]="{ selected: property.uniqueId === selectedPropertyId }"
        (click)="onPropertyItemClick(property)"
      >
        <div class="default-property-item-content">
          <div class="default-property-item-community">
            {{ property.communityName }}
          </div>
          <div class="default-property-item-address">
            {{ property.propertyAddress }}
          </div>
          <div class="default-property-item-id">{{ property.customerId }}</div>
        </div>
      </div>
    </div>
  </div>
</dx-popup>
